import { driver } from "driver.js";
import "driver.js/dist/driver.css"; // 引入driver.js的样式
import { nextTick, ref } from "vue";
export const steer = (options) => {
    if (!options || !Array.isArray(options)) return;
    const driverObj = new driver({
        showProgress: true,
        showButtons: ["next", "previous", "close"], // 是否显示按钮
        steps: options,
        // allowClose: true,
        //这里当引导页完成或者直接关闭放入缓存，下次刷新页面不显示
        onDestroyStarted: () => {
            if (!driverObj.hasNextStep() || confirm("Are you sure?")) {
                driverObj.destroy();
                // 放入缓存
                localStorage.setItem("steer", true);
            }
        },
    });
    driverObj.drive();
    return driverObj;
};

const hasSteered = ref(false); // 用于标记是否已执行过引导
export const getSubMenuTitleElement = async (dom = []) => {
    let steered = localStorage.getItem("steer");
    if (steered) return;
    await nextTick(); // 等待 DOM 更新
    const options = [
        {
            element: dom[0],
            popover: {
                title: "提示",
                nextBtnText: "下一步",
                prevBtnText: "上一步",
                description: "点击展开更多",
                side: "bottom",
            },
        },
        {
            element: dom[1],
            popover: {
                title: "提示",
                nextBtnText: "下一步",
                prevBtnText: "上一步",
                description: "点击切换模块",
                side: "bottom",
            },
        },
        {
            element: dom[2],
            popover: {
                title: "提示",
                nextBtnText: "下一步",
                prevBtnText: "上一步",
                description: "点击切换黑暗/明亮模式",
                side: "bottom",
            },
        },
        {
            element: document.querySelector(".el-menu-item-group"),
            popover: {
                title: "提示",
                nextBtnText: "完成",
                prevBtnText: "上一步",
                description: "点击切换页面",
                side: "bottom",
            },
        },
    ];
    const driverObj = steer(options);
    hasSteered.value = true; // 标记为已执行
    // console.log(driverObj.hasNextStep());
};